import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const instructions = `<p>Import a comma separated value file (CSV) to upload individual tokens. File headers are listed in the
      import instructions below. Extra column headers and their corresponding information will be ignored.</p>
      <p><strong>Import Instructions</strong></p>
      <p>The import system uses CSV files. The file must contain the following fields to successfully import:</p>
      <ul>
        <li>Token ID</li>
        <li>Batch ID</li>
      </ul>
      <p>The following fields are optional:</p>
      <ul>
        <li>Inactive Date</li>
      </ul>`;

export type SPBenefitTokenImportLocs =
	| 'SPBenefitTokenImportTitleSection'
	| 'SPBenefitTokenImportButtonHideInstructions'
	| 'SPBenefitTokenImportButtonShowInstructions'
	| 'SPBenefitTokenImportButtonImport'
	| 'SPBenefitTokenImportContentInstructions'
	| 'SPBenefitTokenImportNotificationMessageImportSuccess';

export const spBenefitTokenImportLocs: LocDefs<SPBenefitTokenImportLocs> = {
	SPBenefitTokenImportTitleSection: {
		defaultValue: 'Individual Token Import',
		description: 'Title for the token import section',
		displayPath: 'Catalogs|Benefit|Tokens|Title|ImportPageSection',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Title.ImportPageSection',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenImportButtonHideInstructions: {
		defaultValue: 'Hide Instructions',
		description: 'Button text to hide the import instructions',
		displayPath: 'Catalogs|Benefit|Tokens|Button|HideInstructions',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Button.HideInstructions',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenImportButtonShowInstructions: {
		defaultValue: 'Show Instructions',
		description: 'Button text to show the import instructions',
		displayPath: 'Catalogs|Benefit|Tokens|Button|ShowInstructions',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Button.ShowInstructions',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenImportButtonImport: {
		defaultValue: 'Import Individual Tokens',
		description: 'Button text to import tokens from CSV file',
		displayPath: 'Catalogs|Benefit|Tokens|Button|Import',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Button.Import',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenImportContentInstructions: {
		defaultValue: instructions,
		description: 'Detailed instructions for importing tokens via CSV file',
		displayPath: 'Catalogs|Benefit|Tokens|Content|Instructions',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Content.Instructions',
		portal: 'SP' as LocPortal,
		htmlAllowed: true,
	},
	SPBenefitTokenImportNotificationMessageImportSuccess: {
		defaultValue: 'Successfully imported tokens',
		description: 'Notification message for successful token import',
		displayPath: 'Catalogs|Benefit|Tokens|Notification|ImportSuccess',
		displayType: 'Notification',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Notification.ImportSuccess',
		portal: 'SP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<SPBenefitTokenImportLocs>(spBenefitTokenImportLocs);
export type SpBenefitTokenImportLocKeys = LocMap<SPBenefitTokenImportLocs>;
